import {
    GET_CATALOG_EQUIPMENT_GRID_DATA,
    GET_CATALOG_MANAGEMENT_GRID_COUNT,
    GET_CATALOG_MANAGEMENT_GRID_DATA, 
    GET_CATALOG_STATUS_DROPDOWN, 
    GET_CATEGORY_DROPDOWN_LIST, 
    GET_DRIVE_TRAIN_DROPDOWN, 
    GET_EQ_CLASS_CODE_DROPDOWN, 
    GET_FUEL_TYPE_DROPDOWN, 
    GET_LENGTH_DROPDOWN_LIST, 
    GET_MAKE_DROPDOWN, 
    GET_MANUFACTURER_DROPDOWN_LIST, 
    GET_MODEL_DROPDOWN_LIST, 
    GET_MODEL_YEAR_DROPDOWN, 
    GET_SEATING_CAPACITY_DROPDOWN_LIST, 
    GET_UPDATED_BY_DROPDOWN_LIST, 
    GET_UPFIT_OPTION_DROPDOWN, 
    GET_VEHICLE_TYPE_DROPDOWN_LIST, 
    SET_CATALOG_EQUIPMENT_GRID_DATA, 
    SET_CATALOG_MANAGEMENT_GRID_COUNT, 
    SET_CATALOG_MANAGEMENT_GRID_DATA,
    SET_CATALOG_STATUS_DROPDOWN,
    SET_CATEGORY_DROPDOWN_LIST,
    SET_DRIVE_TRAIN_DROPDOWN,
    SET_EQ_CLASS_CODE_DROPDOWN,
    SET_FUEL_TYPE_DROPDOWN,
    SET_LENGTH_DROPDOWN_LIST,
    SET_MAKE_DROPDOWN,
    SET_MANUFACTURER_DROPDOWN_LIST,
    SET_MODEL_DROPDOWN_LIST,
    SET_MODEL_YEAR_DROPDOWN,
    SET_SEATING_CAPACITY_DROPDOWN_LIST,
    SET_UPDATED_BY_DROPDOWN_LIST,
    SET_UPFIT_OPTION_DROPDOWN,
    SET_VEHICLE_TYPE_DROPDOWN_LIST,
    GET_ALL_DROP_DOWNS_BASED_ON_SUBTYPE_ID,
    SET_ALL_DROP_DOWNS_BASED_ON_SUBTYPE_ID,
    GET_MODELS_BASED_ON_MAKE,
    SET_MODELS_BASED_ON_MAKE,
    SAVE_CATALOG_ITEM,
    IS_CATALOG_ITEM_SAVED,
    GET_CATALOG_ITEM_BY_ASSET_MODEL_ID,
    SET_CATALOG_ITEM_BY_ASSET_MODEL_ID,
    GET_EQUIPMENT_MODELS_BASED_ON_MAKE,
    GET_CATEGORY2_BASED_ON_CATEGORY,
    SET_CATEGORY2_BASED_ON_CATEGORY,
    GET_CATEGORY_TYPE_BASED_ON_CATEGORY,
    SET_CATEGORY_TYPE_BASED_ON_CATEGORY,
    GET_CATALOG_DASHBOARD_EXCEL_DATA,
    SET_CATALOG_DASHBOARD_EXCEL_DATA,
    VALIDATE_SELECTED_VEHICLE_LEVELS,
    IS_SELECTED_VEHICLE_LEVELS_VALID,
    GET_ASSET_TYPE_OPTIONS,
    SET_ASSET_TYPE_OPTIONS,
    GET_EQ_CLASS_CODE_EXAMPLE,
    SET_EQ_CLASS_CODE_EXAMPLE
} from "./CatalogManagementType"

const getCatalogManagementGridCount = () => ({
    type: GET_CATALOG_MANAGEMENT_GRID_COUNT
});

const setCatalogManagementGridCount = (gridCount: any) => ({
    type: SET_CATALOG_MANAGEMENT_GRID_COUNT,
    gridCount
});

const getCatalogManagementGridData = (payload: any) => ({
    type: GET_CATALOG_MANAGEMENT_GRID_DATA,
    payload
});

const setCatalogManagementGridData = (gridData: any) => ({
    type: SET_CATALOG_MANAGEMENT_GRID_DATA,
    gridData
});

const getCatalogEquipmentGridData = (payload: any) => ({
    type: GET_CATALOG_EQUIPMENT_GRID_DATA,
    payload
});

const setCatalogEquipmentGridData = (gridData: any) => ({
    type: SET_CATALOG_EQUIPMENT_GRID_DATA,
    gridData
});

const getUpfitOptionDropdown = () => ({
    type: GET_UPFIT_OPTION_DROPDOWN
});

const setUpfitOptionDropdown = (data: any) => ({
    type: SET_UPFIT_OPTION_DROPDOWN,
    data
});

const getMakeDropdown = () => ({
    type: GET_MAKE_DROPDOWN
});

const setMakeDropdown = (data: any) => ({
    type: SET_MAKE_DROPDOWN,
    data
});

const getModelDropdownList = (vehicleType:any) => ({
    type: GET_MODEL_DROPDOWN_LIST,
    vehicleType
});

const setModelDropdownList = (data: any) => ({
    type: SET_MODEL_DROPDOWN_LIST,
    data
});

const getFuelTypeDropdown = (vehicleType:any) => ({
    type: GET_FUEL_TYPE_DROPDOWN,
    vehicleType
});

const setFuelTypeDropdown = (data: any) => ({
    type: SET_FUEL_TYPE_DROPDOWN,
    data
});

const getEqClassCodeDropdown = () => ({
    type: GET_EQ_CLASS_CODE_DROPDOWN
});

const setEqClassCodeDropdown = (data: any) => ({
    type: SET_EQ_CLASS_CODE_DROPDOWN,
    data
});

const getCatalogStatusDropdown = () => ({
    type: GET_CATALOG_STATUS_DROPDOWN
});

const setCatalogStatusDropdown = (data: any) => ({
    type: SET_CATALOG_STATUS_DROPDOWN,
    data
});

const getDriveTrainDropdown = () => ({
    type: GET_DRIVE_TRAIN_DROPDOWN
});

const setDriveTrainDropdown = (data: any) => ({
    type: SET_DRIVE_TRAIN_DROPDOWN,
    data
});

const getModelYearDropdown = (vehicleType:any) => ({
    type: GET_MODEL_YEAR_DROPDOWN,
    vehicleType
});

const setModelYearDropdown = (data: any) => ({
    type: SET_MODEL_YEAR_DROPDOWN,
    data
});

const getVehicleTypeDropdownList = () => ({
    type: GET_VEHICLE_TYPE_DROPDOWN_LIST
});

const setVehicleTypeDropdownList = (data: any) => ({
    type: SET_VEHICLE_TYPE_DROPDOWN_LIST,
    data
});

const getUpdatedByDropdownList = () => ({
    type: GET_UPDATED_BY_DROPDOWN_LIST
});

const setUpdatedByDropdownList = (data: any) => ({
    type: SET_UPDATED_BY_DROPDOWN_LIST,
    data
});

const getAllDropdownBySubTypeId = (subTypeId: number, isVehicle: boolean = false) => ({
    type: GET_ALL_DROP_DOWNS_BASED_ON_SUBTYPE_ID,
    subTypeId,
    isVehicle
});

const setAllDropdownBySubTypeId = (allDropdownsBySubTypeId: any) => ({
    type: SET_ALL_DROP_DOWNS_BASED_ON_SUBTYPE_ID,
    allDropdownsBySubTypeId
})
const getManufacturerDropdownList = (vehicleType:any) => ({
    type: GET_MANUFACTURER_DROPDOWN_LIST,
    vehicleType
});

const setManufacturerDropdownList = (data: any) => ({
    type: SET_MANUFACTURER_DROPDOWN_LIST,
    data
});

const getCategoryDropdownList = (vehicleType:any) => ({
    type: GET_CATEGORY_DROPDOWN_LIST,
    vehicleType
});

const setCategoryDropdownList = (data: any) => ({
    type: SET_CATEGORY_DROPDOWN_LIST,
    data
});

const getLengthDropdownList = (vehicleType:any) => ({
    type: GET_LENGTH_DROPDOWN_LIST,
    vehicleType
});

const setLengthDropdownList = (data: any) => ({
    type: SET_LENGTH_DROPDOWN_LIST,
    data
});

const getSeatingCapacityDropdownList = (vehicleType:any) => ({
    type: GET_SEATING_CAPACITY_DROPDOWN_LIST,
    vehicleType
});

const setSeatingCapacityDropdownList = (data: any) => ({
    type: SET_SEATING_CAPACITY_DROPDOWN_LIST,
    data
});

const getModelsBasedOnMake = (make: string, subType: string) => ({
    type: GET_MODELS_BASED_ON_MAKE,
    make,
    subType
});

const getEquipmentModelsBasedOnMake = (make: string, subType: string) => ({
    type: GET_EQUIPMENT_MODELS_BASED_ON_MAKE,
    make,
    subType
});

const setModelsBasedOnMake = (data: any) => ({
    type: SET_MODELS_BASED_ON_MAKE,
    data
});

const saveCatalogItem = (payload: any) => ({
    type: SAVE_CATALOG_ITEM,
    payload
});

const setIsCatalogItemSaved = (flag: any) => ({
    type: IS_CATALOG_ITEM_SAVED,
    flag
});

const getCatalogItemByAssetModelId = (assetModelId: any) => ({
    type: GET_CATALOG_ITEM_BY_ASSET_MODEL_ID,
    assetModelId
});

const setCatalogItemByAssetModelId = (catalogItem: any) => ({
    type: SET_CATALOG_ITEM_BY_ASSET_MODEL_ID,
    catalogItem
});

const getCategory2BasedOnCategory = (categoryId : any) => ({
    type: GET_CATEGORY2_BASED_ON_CATEGORY,
    categoryId 
});

const setCategory2BasedOnCategory = (category2List: any) => ({
    type: SET_CATEGORY2_BASED_ON_CATEGORY,
    category2List
});

const getCategoryTypeBasedOnCategory = (categoryId : any) => ({
    type: GET_CATEGORY_TYPE_BASED_ON_CATEGORY,
    categoryId 
});

const setCategoryTypeBasedOnCategory = (categoryTypeList: any) => ({
    type: SET_CATEGORY_TYPE_BASED_ON_CATEGORY,
    categoryTypeList
});


const getCatalogDashboardExcelData = (payload: any, catalogType: string) => ({
    type: GET_CATALOG_DASHBOARD_EXCEL_DATA,
    payload,
    catalogType
});

const setCatalogDashboardExcelData = (response: any) => ({
    type: SET_CATALOG_DASHBOARD_EXCEL_DATA,
    response
});

const validateSelectedVehicleLevels = (payload: any) => ({
    type: VALIDATE_SELECTED_VEHICLE_LEVELS,
    payload
});

const setIsSelectedVehicleLevelValid = (response: any) => ({
    type: IS_SELECTED_VEHICLE_LEVELS_VALID,
    response
});

const getAssetTypeOptions = () => ({
    type: GET_ASSET_TYPE_OPTIONS
});

const setAssetTypeOption = (response: any) => ({
    type: SET_ASSET_TYPE_OPTIONS,
    response
});

const getEqClassCodeExample = (subTypeId: number) => ({
    type: GET_EQ_CLASS_CODE_EXAMPLE,
    subTypeId
});

const setEqClassCodeExample = (response: any) => ({
    type: SET_EQ_CLASS_CODE_EXAMPLE,
    response
});

export {
    getCatalogManagementGridData,
    setCatalogManagementGridData,
    getCatalogEquipmentGridData,
    setCatalogEquipmentGridData,
    getCatalogManagementGridCount,
    setCatalogManagementGridCount,
    getUpfitOptionDropdown,
    setUpfitOptionDropdown,
    getMakeDropdown,
    setMakeDropdown,
    getModelDropdownList,
    setModelDropdownList,
    getFuelTypeDropdown,
    setFuelTypeDropdown,
    getEqClassCodeDropdown,
    setEqClassCodeDropdown,
    getCatalogStatusDropdown,
    setCatalogStatusDropdown,
    getDriveTrainDropdown,
    setDriveTrainDropdown,
    getModelYearDropdown,
    setModelYearDropdown,
    getVehicleTypeDropdownList,
    setVehicleTypeDropdownList,
    getUpdatedByDropdownList,
    setUpdatedByDropdownList,
    getAllDropdownBySubTypeId,
    setAllDropdownBySubTypeId,
    getManufacturerDropdownList,
    setManufacturerDropdownList,
    getCategoryDropdownList,
    setCategoryDropdownList,
    getLengthDropdownList,
    setLengthDropdownList,
    getSeatingCapacityDropdownList,
    setSeatingCapacityDropdownList,
    getModelsBasedOnMake,
    setModelsBasedOnMake,
    saveCatalogItem,
    setIsCatalogItemSaved,
    getCatalogItemByAssetModelId,
    setCatalogItemByAssetModelId,
    getEquipmentModelsBasedOnMake,
    getCategory2BasedOnCategory,
    setCategory2BasedOnCategory,
    getCategoryTypeBasedOnCategory,
    setCategoryTypeBasedOnCategory,
    getCatalogDashboardExcelData,
    setCatalogDashboardExcelData,
    validateSelectedVehicleLevels,
    setIsSelectedVehicleLevelValid,
    getAssetTypeOptions,
    setAssetTypeOption,
    getEqClassCodeExample,
    setEqClassCodeExample
}